module.exports = __webpack_public_path__ + "img/vertical_2_1_3009.63e28478.png";